<!--
isChoose
1、生产主体
2、经营主体
3、收购单位（个人）
4、生产者
-->
<template>
  <div v-if="isNewOrOld == 1" class="cert-old">
    <div class="title">合格证</div>
    <div class="box">
      <div class="header">
        <div class="cert-text">食用农产品合格证</div>
        <div class="cert-no">编号：{{ info.certificateNo }}</div>
      </div>
      <div class="main">
        <div class="item">
          <div class="left">食用农产品名称</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.productName }}</div>
        </div>
        <div class="item">
          <div class="left">数量（重量）</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.quantity }}</div>
        </div>
        <div class="item">
          <div class="left">产地</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.productAddress }}</div>
        </div>
        <div class="item">
          <div class="left">生产者盖章或签名</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.sign }}</div>
        </div>
        <div class="item">
          <div class="left">联系方式</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.contact }}</div>
        </div>
        <div class="item">
          <div class="left">开具日期</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.issueDate }}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-desc">
          我承诺对产品质量安全以及合格证真实性负责：
        </div>
        <div class="bottom-check">
          <Checkbox
              v-model="info.noUsePesticides"
              :true-value="1"
              :false-value="0"
              disabled
          ><span style="color: #000000; cursor: not-allowed">不使用禁限用农药兽药</span>
          </Checkbox>
          <Checkbox
              v-model="info.noUseInvalidAdd"
              :true-value="1"
              :false-value="0"
              disabled
          ><span style="color: #000000; cursor: not-allowed">不使用非法添加物</span>
          </Checkbox>
          <Checkbox
              v-model="info.followPesticidesRule"
              :true-value="1"
              :false-value="0"
              disabled
          >
            <span style="color: #000000; cursor: not-allowed">遵守农药安全间隔期、兽药休药期规定</span>
          </Checkbox>
          <Checkbox
              v-model="info.meetCriterion"
              :true-value="1"
              :false-value="0"
              disabled
          >
            <span style="color: #000000; cursor: not-allowed">销售的食用农产品符合农药兽药残留食品安全国家标准</span>
          </Checkbox>
        </div>
        <div class="bottom-desc">品质保障方式：</div>
        <div class="bottom-check1">
          <Checkbox
              v-model="info.selfCheckValid"
              :true-value="1"
              :false-value="0"
              disabled
          >
            <span style="color: #000000; cursor: not-allowed">自检合格</span>
          </Checkbox>
          <Checkbox
              v-model="info.entrustCheckValid"
              :true-value="1"
              :false-value="0"
              disabled
          >
            <span style="color: #000000; cursor: not-allowed">委托检验合格</span>
          </Checkbox>
          <Checkbox
              v-model="info.qualityControlValid"
              :true-value="1"
              :false-value="0"
              disabled
          >
            <span style="color: #000000; cursor: not-allowed">质量控制合格</span>
          </Checkbox>
          <Checkbox
              v-model="info.selfPromiseValid"
              :true-value="1"
              :false-value="0"
              disabled
          >
            <span style="color: #000000; cursor: not-allowed">自我承诺合格</span>
          </Checkbox>
        </div>
        <div class="bottom-qr">
          <Image
              :src="info.certificateImageUrl"
              fit="cover"
              width="60px"
              height="60px"
          />
          <div class="qr-text">扫码查看电子信息</div>
        </div>
        <div class="bottom-desc">
          <span>追溯码：</span>
          <span class="trace-code"></span>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isNewOrOld == 2" class="cert-new">
    <div class="box">
      <div class="header">
        <div class="cert-text">承诺达标合格证</div>
        <div class="cert-no">
          {{ isChoose == 1 ? '（生产主体）' : isChoose == 2 ? '（经营主体）' : '' }}
        </div>
        <div class="cert-no">编号：{{ info.certificateNo }}</div>
      </div>
      <div class="bottom">
        <div class="bottom-desc">我承诺对生产销售的食用农产品：</div>
        <div class="bottom-check">
          <Checkbox v-model="info.noUsePesticides" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">
              {{
                isChoose == 1 ? '不使用禁用农药兽药、停用兽药和非法添加物'
                    : isChoose == 2 ? '已收取并保存该批次产品的承诺达标合格证或者其他质量安全合格证明'
                        : ''
              }}
            </span>
          </Checkbox>
          <Checkbox v-model="info.noUseInvalidAdd" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">
              {{
                isChoose == 1 ? '常规农药兽药残留不超标'
                    : isChoose == 2 ? '不违规使用保鲜剂、防腐剂、添加剂等'
                        : ''
              }}
            </span>
          </Checkbox>
          <Checkbox v-model="info.followPesticidesRule" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">对承诺的真实性负责</span>
          </Checkbox>
        </div>
        <div class="bottom-desc">承诺依据：</div>
        <div class="bottom-check">
          <Checkbox v-model="info.meetCriterion" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">委托检测</span>
          </Checkbox>
          <Checkbox v-model="info.selfCheckValid" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">自我检测</span>
          </Checkbox>
          <Checkbox v-model="info.entrustCheckValid" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">内部质量控制</span>
          </Checkbox>
          <Checkbox v-model="info.qualityControlValid" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">自我承诺</span>
          </Checkbox>
        </div>
      </div>
      <div class="main">
        <div class="item">
          <div class="left">产品名称</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.productName }}</div>
        </div>
        <div class="item">
          <div class="left">数量（重量）</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.quantity == 0 ? '' : info.quantity }}</div>
        </div>
        <div class="item">
          <div class="left">基数</div>
          <div class="symbol">：</div>
          <div class="right">
            {{ info.baseNumber == 0 ? '' : info.baseNumber }}
          </div>
        </div>
        <div class="item">
          <div class="left">产地</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.productAddress }}</div>
        </div>
        <div class="item" v-if="!isAttachment">
          <div class="left">
            {{ isChoose == 1 ? '生产' : isChoose == 2 ? '经营' : '' }}者盖章或签名
          </div>
          <div class="symbol">：</div>
          <Image v-if="info.sign != null" :src="info.sign" fit="contain" width="60px" height="60px"/>
        </div>
        <div class="item">
          <div class="left">联系方式</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.contact }}</div>
        </div>
        <div class="item">
          <div class="left">开具日期</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.issueDate }}</div>
        </div>
        <div class="item" style="margin-top: 40px; box-sizing: border-box" v-if="isAttachment">
          <div class="left">附件</div>
          <div class="symbol">：</div>
          <div v-for="item in info.attachment?info.attachment.split(',').filter(Boolean):[]" :key="item">
            <Image style="margin-left: 10px; margin-bottom: 40px" :src="item" fit="contain" width="60px" height="60px"
                   @click="showFullscreenImage(item)"/>
          </div>
        </div>
      </div>
      <div class="bottom-qr" v-if="isAttachment">
        <Image :src="info.certificateImageUrl" fit="cover" width="60px" height="60px"/>
      </div>
      <div class="bottom-qr" v-if="!isAttachment" @click="goToDetail">
        <Image :src="info.certificateImageUrl" fit="cover" width="60px" height="60px"/>
        <div class="qr-text">点击查看检测详情</div>
      </div>
    </div>
  </div>
  <div v-if="isNewOrOld == 3" class="cert-new">
    <div class="box">
      <div class="header">
        <div class="cert-text">承诺达标合格证</div>
        <div class="cert-no">
          {{ isChoose == 3 ? '收购单位（个人）' : isChoose == 4 ? '生产者' : '' }}
        </div>
        <div class="cert-no">编号：{{ info.certificateNo }}</div>
      </div>
      <div class="bottom">
        <div class="bottom-desc" style="font-weight: bold">
          我承诺{{ isChoose == 3 ? '' : isChoose == 4 ? '生产' : '' }}销售的食用农产品:
        </div>
        <div class="bottom-check">
          <span style="color: #000000; cursor: not-allowed">
            {{
              isChoose == 3 ? '已按规定收取并保存该批次农产品承诺达标合格证或者其他质量安全合格证明;'
                  : isChoose == 4 ? '未使用禁用农药、兽药及其他化合物;'
                      : ''
            }}
          </span>
          <span style="color: #000000; cursor: not-allowed">
            {{
              isChoose == 3 ? '未违规使用保鲜剂、防腐剂、添加剂等。'
                  : isChoose == 4 ? '使用的常规农药、兽药残留不超标。'
                      : ''
            }}
          </span>
        </div>
        <div class="bottom-desc" style="font-weight: bold">承诺依据：</div>
        <div class="bottom-check">
          <Checkbox v-model="info.noUsePesticides" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">质量安全控制符合要求</span>
          </Checkbox>
          <Checkbox v-model="info.noUseInvalidAdd" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">自行检测合格</span>
          </Checkbox>
          <Checkbox v-model="info.followPesticidesRule" :true-value="1" :false-value="0" disabled>
            <span style="color: #000000; cursor: not-allowed">委托检测合格</span>
          </Checkbox>
        </div>
      </div>
      <div style="
          border-bottom: solid 1px #000000;
          width: 90%;
          margin: 0 auto;
          margin-top: 20px;
        "></div>
      <div class="main">
        <div class="item">
          <div class="left">产品名称</div>
          <div class="symbol">：</div>
          <div class="right" style="">{{ info.productName }}</div>
        </div>
        <div class="item">
          <div class="left">重量或数量</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.quantity == 0 ? '' : info.quantity }}</div>
        </div>
        <div class="item" v-if="isChoose == 4">
          <div class="left">产地</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.productAddress }}</div>
        </div>
        <div class="item">
          <div class="left">承诺主体</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.sign }}</div>
        </div>
        <div class="item">
          <div class="left">联系方式</div>
          <div class="symbol">：</div>
          <div class="right">{{ info.contact }}</div>
        </div>
        <div class="item">
          <div class="left">开具日期</div>
          <div class="symbol">：</div>
          <div class="right">{{ formatChineseDate(info.issueDate) }}</div>
        </div>
        <div class="item" style="margin-top: 40px; box-sizing: border-box" v-if="isAttachment">
          <div class="left">附件</div>
          <div class="symbol">：</div>
          <div v-for="item in info.attachment?info.attachment.split(',').filter(Boolean):[]" :key="item">
            <Image style="margin-left: 10px; margin-bottom: 40px" :src="item" fit="contain" width="60px" height="60px"
                   @click="showFullscreenImage(item)"/>
          </div>
        </div>
      </div>
      <div class="bottom-qr" v-if="isAttachment">
        <div class="qr-text">承诺达标合格证</div>
        <Image :src="info.certificateImageUrl" fit="cover" width="60px" height="60px"/>
      </div>
      <div class="bottom-qr" v-if="!isAttachment" @click="goToDetail">
        <div class="qr-text">承诺达标合格证</div>
        <Image :src="info.certificateImageUrl" fit="cover" width="60px" height="60px"/>
        <div class="qr-text">点击查看检测详情</div>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <div v-if="showFullscreen" class="fullscreen-modal" @click.self="showFullscreen = false">
      <div class="fullscreen-modal-content">
        <button class="fullscreen-modal-close" type="button" @click="showFullscreen = false">×</button>
        <Image class="fullscreen-image" :src="fullscreenImageUrl" fit="contain" @error="handleImageError"/>
      </div>
    </div>
  </Teleport>
</template>
<script>
import axios from 'axios'
import { useRouter } from 'vue-router'

export default {
  name: 'CertView',
  setup() {
    const router = useRouter()
    return {
      router
    }
  },
  data() {
    return {
      showFullscreen: false, // 是否显示全屏图片
      fullscreenImageUrl: '', // 全屏图片地址url
      isNewOrOld: 0,
      isAttachment: false,
      isChoose: 0,
      to: '',
      info: {},
      VUE_APP_API_URL: process.env.VUE_APP_API_URL
    }
  },
  created() {
    document.title = '合格证信息'
    this.getCertInfo()
  },
  methods: {
    handlePrint() {
      const printDom = document.querySelector('.cert-new') || document.querySelector('.cert-old')
      if (!printDom) {
        this.$message?.error('未找到打印内容')
        return
      }
      const printWrapper = document.createElement('div')
      document.body.appendChild(printWrapper)
      this.$nextTick(() => {
        window.print()
        setTimeout(() => {
          document.body.removeChild(printWrapper)
        }, 100)
      })
    },
    showFullscreenImage(url) {
      this.fullscreenImageUrl = url
      this.showFullscreen = true
    },
    getCertInfo() {
      axios.get(`${this.VUE_APP_API_URL}/open/certInfo/${this.$route.params.id}`)
          .then((response) => {
            if (response.data.code === 200) {
              this.to = `/Cert_check/${response.data.data.sysSampleId}`
              if (
                  response.data.data.deviceId.includes('PDA')
                  || response.data.data.deviceId.includes('miniProgram')
              ) {
                this.isNewOrOld = 2
              } else {
                this.isNewOrOld = 1
              }
              if (response.data.data.deviceId.includes('生产主体')) {
                this.isChoose = 1
              } else if (response.data.data.deviceId.includes('经营主体')) {
                this.isChoose = 2
              } else if (
                  response.data.data.deviceId.includes('收购单位（个人）')
              ) {
                this.isChoose = 3
                this.isNewOrOld = 3
              } else if (response.data.data.deviceId.includes('生产者')) {
                this.isChoose = 4
                this.isNewOrOld = 3
              }
              this.isAttachment = response.data.data.deviceId.includes('自填')
              Object.assign(this.info, response.data.data)
              if (this.$route.params.print === 'true' || this.$route.params.print === true) {
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.handlePrint()
                  }, 1500)
                })
              }
            }
          })
    },
    goToDetail() {
      this.$router.push(this.to)
    },
    formatChineseDate(date) {
      if (!date) {
        return ''
      }
      const [year, month, day] = date.split('-')
      return `${year || ''}年${month || ''}月${day || ''}日`
    },
    handleImageError() {
      this.$message?.error('图片加载失败')
      this.showFullscreen = false
    }
  }
}
</script>
<style lang="less" scoped>
.fullscreen-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  // 黑色半透明遮罩
  background: rgba(0, 0, 0, 0.55);

  .fullscreen-modal-content {
    position: relative;
    width: min(90vw, 700px);
    height: min(80vh, 600px);
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fullscreen-modal-close {
    position: absolute;
    top: 8px;
    right: 12px;
    z-index: 2;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    color: #666666;
    background: rgba(0, 0, 0, 0.06);
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;

    &:hover {
      color: #ffffff;
      background: #f56c6c;
    }
  }

  .fullscreen-image {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // Image 组件内部真正的 img
    :deep(img) {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
}

@media screen and (max-width: 600px) {
  .fullscreen-modal {
    padding: 12px;

    .fullscreen-modal-content {
      width: 94vw;
      height: 70vh;
      padding: 15px;
      border-radius: 8px;
    }
  }
}

.cert-old {
  padding: 20px;

  .title {
    font-size: 18px;
    text-align: center;
  }

  .box {
    border: solid 1px #000000;
    margin-top: 20px;

    .header {
      border-bottom: solid 1px #000000;
      text-align: center;

      .cert-text {
        font-size: 22px;
        font-weight: bold;
        color: #01ac45;
        margin: 20px 0 5px;
      }

      .cert-no {
        font-size: 18px;
        color: #c21f15;
        margin-bottom: 10px;
      }
    }

    .main {
      border-bottom: solid 1px #000000;

      .item {
        padding: 0 20px;
        display: flex;
        align-items: center;
        height: 32px;
        font-size: 15px;
        color: #000000;

        .left {
          width: 120px;
          height: 32px;
          line-height: 32px;
          font-weight: bold;
          text-align: justify;

          &::after {
            content: "";
            width: 100%;
            display: inline-block;
            height: 0;
          }
        }

        .symbol {
          font-weight: bold;
        }

        .right {
          height: 20px;
          padding-left: 10px;
          border-bottom: solid 1px #000000;
          flex: 1;
        }
      }
    }

    .bottom {
      .bottom-desc {
        font-size: 15px;
        color: #01ac45;
        padding: 5px 0 0 5px;

        .trace-code {
          display: inline-block;
          width: 100px;
          height: 20px;
          padding-left: 10px;
          border-bottom: solid 1px #01ac45;
        }
      }

      .bottom-check {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 5px 0 0 10px;
      }

      .bottom-check1 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 5px;
        padding: 5px 0 0 10px;
      }

      .bottom-qr {
        text-align: center;
        padding: 30px 0 0;

        .qr-text {
          color: #000000;
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
  }
}

.cert-new {
  position: relative;
  padding: 20px;

  .box {
    border: solid 1px #000000;
    margin-top: 20px;

    .header {
      text-align: center;

      .cert-text {
        font-size: 22px;
        font-weight: bold;
        color: black;
        margin: 20px 0 5px;
      }

      .cert-no {
        font-size: 14px;
        color: black;
        margin-bottom: 10px;
      }
    }

    .main {
      margin-top: 20px;

      .item {
        padding: 0 20px;
        display: flex;
        font-size: 15px;
        color: #000000;
        line-height: 1;

        .left {
          width: 130px;
          font-weight: bold;
          text-align: justify;

          &::after {
            content: "";
            width: 100%;
            display: inline-block;
            height: 0;
          }
        }

        .symbol {
          font-weight: bold;
        }

        .right {
          flex: 1;
          word-wrap: break-word;
          min-height: 20px;
        }
      }
    }

    .bottom {
      .bottom-desc {
        font-size: 15px;
        color: black;
        padding: 5px 0 0 5px;
      }

      .bottom-check {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 5px 0 0 10px;
      }
    }

    .bottom-qr {
      text-align: center;
      padding: 30px 0 0;

      .qr-text {
        color: #000000;
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
}

.cert-new::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  pointer-events: none;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="60" viewBox="0 0 100 60"><text x="0" y="40" font-size="12" fill="rgba(0,0,0,0.08)" transform="rotate(-20)" font-weight="bold" font-family="Arial">承诺达标合格证</text></svg>') repeat;
  opacity: 0.5;
}
</style>
<style>
@media print {
  .fullscreen-modal {
    display: none !important;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
    visibility: visible !important;
  }

  html, body {
    visibility: visible !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
  }

  #app, .cert-old, .cert-new {
    visibility: visible !important;
    position: static !important;
    left: auto !important;
    top: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto !important;
    padding: 10px !important;
    display: block !important;
    page-break-inside: avoid !important;
  }

  .box {
    border: 1px solid #000 !important;
    visibility: visible !important;
  }

  img {
    visibility: visible !important;
    display: block !important;
    max-width: 100% !important;
    height: auto !important;
  }

  /* 隐藏不需要打印的元素 */
  .el-dialog__wrapper,
  .ivu-modal,
  .header-nav,
  .sidebar,
  .print-hide {
    display: none !important;
  }
}
</style>
<style lang="less">
/* 强制Checkbox选中对号为纯黑色 */
html body {
  .ivu-checkbox-inner {
    width: 16px !important;
    height: 16px !important;
    border: 1px solid #000 !important;
    background: #ffffff !important;
    border-radius: 0 !important;
    position: relative !important;
    z-index: 1 !important;
  }

  /* 选中状态 - 核心强制黑色对号 */

  &.ivu-checkbox-checked {
    .ivu-checkbox-inner {
      background: #ffffff !important;
      border-color: #000 !important;
      box-shadow: none !important;
    }

    .ivu-checkbox-inner::after {
      /* 覆盖所有内置样式：重新定义对号 */
      content: "" !important;
      position: absolute !important;
      left: 5px !important;
      top: 1px !important;
      width: 6px !important;
      height: 10px !important;
      border: 2px solid #000000 !important; /* 纯黑 */
      border-top: none !important;
      border-left: none !important;
      transform: rotate(45deg) !important;
      transform-origin: center center !important;
      opacity: 1 !important;
      filter: none !important; /* 清除灰度滤镜 */
      box-sizing: border-box !important;
      z-index: 2 !important;
    }
  }

  /* 禁用+选中状态 - 强制黑色对号 */

  &.ivu-checkbox-disabled {
    opacity: 1 !important;

    .ivu-checkbox-inner {
      opacity: 1 !important;
      border-color: #000 !important;
    }

    &.ivu-checkbox-checked .ivu-checkbox-inner::after {
      border-color: #000 !important;
      opacity: 1 !important;
      filter: none !important;
    }

    .ivu-checkbox-label {
      color: #000 !important;
      cursor: not-allowed !important;
    }
  }
}

/* 兜底：覆盖iview全局Checkbox样式 */
.ivu-checkbox {
  &.ivu-checkbox-checked {
    .ivu-checkbox-inner::after {
      border-color: #000 !important;
      opacity: 1 !important;
    }
  }

  &.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner::after {
    border-color: #000 !important;
    opacity: 1 !important;
  }
}
</style>
